import { Component, ElementRef, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {cloneDeep, reverse} from 'lodash';
import { debounceTime, Observable } from 'rxjs';
import { Debounce } from 'src/app/helpers/utils';
import { LocationsService } from 'src/app/services/locations.service';
import { PlayersService } from 'src/app/services/players.service';
import { TournamentService } from 'src/app/services/tournament.service';
import { CreatePlayerModalComponent } from '../create-player-modal/create-player-modal.component';
import {TournamentTunerComponent} from '../private-office/tournament-tuner/tournament-tuner.component';
import {TournamentTunerMethodsService} from "../../services/tournament-tuner-methods.service";
import { PlayerDeleteModalComponent } from './player-delete-modal/player-delete-modal.component';
@Component({
  selector: 'app-players',
  templateUrl: './players.component.html',
  styleUrls: ['./players.component.scss']
})
export class PlayersComponent implements OnInit {

  @Input() tournamentId: number = 0;
  @Input() isStaff;

  public tournament: any;
  public players: any;
  private _playersOfInitialOrder;
  private _amountOfCommittedClicks: number = 0;
  private _maxAmountOfCommittedClicks: number = 3;

  public searchForm;
  public searchResults;

  private searchObservable: EventEmitter<string> = new EventEmitter();
  private _inputIdentifiersList: string[] = [];
  private _inputIdentifierPrefix: string = 'tn-';
  private _lastFocusedInputIndex: number = -1;

  private _chosenColumnNameToSortBy = '';

  // private titlesDict = {
  //   '3un': '3юн',
  //   '2un': '2юн',
  //   '1un': '1юн',
  //   '1': 'I',
  //   '2': 'II',
  //   '3': 'III',
  //   'kms': 'КМС',
  //   'ms': 'МС',
  //   'msmk': 'МСМК',
  //   'zms': 'ЗМС',
  //   '-': '-',
  // };
  private titlesOrders = {
    '-': 1,
    '3юн': 2,
    '2юн': 3,
    '1юн': 4,
    'I': 5,
    'II': 6,
    'III': 7,
    'КМС': 8,
    'МС': 9,
    'МСМК': 10,
    'ЗМС': 11,
  };

  @ViewChild('searchInput') searchInput: ElementRef;

  public tablesSorting = {};

  constructor(
    private playersService: PlayersService,
    private tournamentService: TournamentService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private locationsService: LocationsService,
    private tournamentTunerService: TournamentTunerMethodsService,
  ) {
    this.searchForm = this.formBuilder.group({
      query: ['', []],
    });
  }

  ngOnInit(): void {

    this.isStaff = (this.isStaff === 'True');
    this.updateTournament();

    this.updatePlayersList();
    let timeOut;
    this.searchObservable.pipe(debounceTime(300)).subscribe((query) => {
      if (query && this.searchForm.controls.query.value === query) {
        this.playersService.search(query, this.tournamentId).subscribe(players => {
          if (query && this.searchForm.controls.query.value === query) {
            this.searchResults = players; // сохранёны такие результаты, в которых строка query входит подстрокой
            // в какое-либо строковое свойство игрока, в т.ч. его фамилию
            // поэтому для исправления поиска данный результат достаточно пропустить через фильтрацию как ниже
            this.searchResults = this.searchResults.filter((player) => player.last_name.toLowerCase().startsWith(query.toLowerCase()));
          }
        });
      }
      // if (timeOut) {
      //   clearTimeout(timeOut);
      // }
      // timeOut = setTimeout(() => {
      // }, 500);
      // this.playersService.search(query, this.tournamentId).subscribe(players => {
      //   this.searchResults = players; // сохранёны такие результаты, в которых строка query входит подстрокой
      //   // в какое-либо строковое свойство игрока, в т.ч. его фамилию
      //   // поэтому для исправления поиска данный результат достаточно пропустить через фильтрацию как ниже
      //   this.searchResults = this.searchResults.filter((player) => player.last_name.toLowerCase().startsWith(query.toLowerCase()));
      // });
    });
  }


  @Debounce(300)
  updatePlayerTournamentNumber(player: any) {
    player.saving = true;
    this.playersService.updateTournamentNumbers(this.tournamentId, [player]).subscribe((players) => {
      // this.players = players;
      // this.updateTournament();
    });
  }

  onEnterHandler($event) {
    if ($event.key === 'Enter') {
      this.lastFocusedInputIndex = -1;
      $event.target.blur();
    } else {
      if ($event.keyCode === 40) {
        if (this.lastFocusedInputIndex < this.getInputIdentifiersListLength() - 1) {
          this.lastFocusedInputIndex ++;
        }
        this.focusInput(this.getInputIdentifierByIndex(this.lastFocusedInputIndex));
      } else if ($event.keyCode === 38) {
        if (this.lastFocusedInputIndex > 0) {
          this.lastFocusedInputIndex --;
        }
        this.focusInput(this.getInputIdentifierByIndex(this.lastFocusedInputIndex));
      }
    }
  }

  focusInput(identifier: string) {
    if (identifier) {
     const inputTag = document.getElementById(identifier);
     if (inputTag) {
       inputTag.focus();
     }
    }
  }

  onInputFocusHandler(index: number) {
    this.lastFocusedInputIndex = index;
  }

  inputModelChangeHandler() {
    // console.debug('input model has been changes!');
  }

  openTournamentTuner() {
    this.tournamentTunerService.tournamentId = this.tournamentId;
    const modalRef = this.modalService.open(TournamentTunerComponent, {
      size: 'lg',
    });
    // @ts-ignore
    this.tournamentTunerService.playersAmount = this.players.length;
  }

  resetLottery() {
    this.playersService.resetLottery(this.tournamentId).subscribe((players) => {
      this.players = players;

      this.updateTournament();
    })
  }

  lottery(type?: string) {
    this.playersService.lottery(this.tournamentId, type).subscribe((players) => {
      this.players = players;
      this.updateTournament();
    })
  }

  createBracket() {
    this.playersService.create_brackets(this.tournamentId).subscribe((players) => {
      window.location.href = window.location.href.replace('players', 'bracket');
    })
  }

  updateTournament() {
    this.tournamentService.get(this.tournamentId).subscribe(tournament => {
      this.tournament = tournament;
      // if (this.lastFocusedInputIndex >= 0) {
      //   document.getElementById(this.getInputIdentifierByIndex(this.lastFocusedInputIndex)).focus();
      // }
    });
  }

  updatePlayersList() {
    this.playersService.get(this.tournamentId).subscribe(players => {
      this.players = players;
      this._playersOfInitialOrder = cloneDeep(this.players);
      this.players.forEach((player) => {
        this.appendInputIdentifier(this._inputIdentifierPrefix + player.id);
      });

    });
  }

  search() {
    if (this.searchForm.controls.query.value.length == 0) {
      this.searchResults = null;
      return;
    }
    this.searchObservable.emit(this.searchForm.controls.query.value);
  }

  addPlayer(player: any) {
    let index = this.searchResults.indexOf(player);
    if (index > -1) {
      this.searchResults.splice(index, 1);
    }

    this.playersService.addPlayer(this.tournamentId, player.id).subscribe(() => {
      this.updatePlayersList();
    });

    this.searchInput.nativeElement.select();
  }

  removePlayer(player: any) {
    const modalRef = this.modalService.open(PlayerDeleteModalComponent, {
        size: 'md',
        centered: true
    });
    modalRef.componentInstance.playerId = player.id;
    modalRef.componentInstance.tournamentId = this.tournamentId;
    modalRef.componentInstance.tournamentBracketFormed = this.tournament.bracket_formed;
    modalRef.result.then(() => {
      this.updatePlayersList();
      this.searchForm.query.value = null;
      this.searchResults = null;
    });

    //let index = this.players.indexOf(player);
    //if (index > -1) {
    //  this.players.splice(index, 1);
    //}
  }

  createPlayer() {
    const query = this.searchForm.controls.query.value;
    const splittedQuery = query.split(' ');
    const player = {
      first_name: splittedQuery[1],
      last_name: splittedQuery[0],
    };

    const modalRef = this.modalService.open(CreatePlayerModalComponent, {
      size: 'lg'
    });
    modalRef.componentInstance.player = player;
    modalRef.componentInstance.tournamentId = this.tournamentId;
    modalRef.result.then(() => {
      this.updatePlayersList();
      this.searchForm.query.value = null;
      this.searchResults = null;
    }, () => {
      this.updatePlayersList();
      this.searchForm.query.value = null;
      this.searchResults = null;
    });
  }

  editPlayer(player) {
    const open = (p) => {
      const modalRef = this.modalService.open(CreatePlayerModalComponent, {
        size: 'lg'
      });
      modalRef.componentInstance.player = p;
      modalRef.componentInstance.edit = true;
      modalRef.componentInstance.tournamentId = this.tournamentId;
      modalRef.result.then(() => {
        this.updatePlayersList();
        this.search();
      }, () => {
        this.updatePlayersList();
        this.search();
      });
    }


    this.playersService.getPlayer(player.id).subscribe((p: any) => {
      // if (p.city) {
      //   this.locationsService.getById(p.city).subscribe((city) => {
      //     p.city = city;
      //     open(p)
      //   });
      // } else {
      open(p);
      // }

    });
  }

  isSortingByField(table_name, s_field_name, s_reverse) {
    const {field_name, reverse} = this.tablesSorting[table_name] ? this.tablesSorting[table_name] : {field_name: null, reverse: false};

    return s_field_name == field_name && s_reverse == reverse;
  }

  sortBy(table_name, field_name) {
    let theSameName = this.chosenColumnNameToSortBy === field_name;

    this.incrementCommittedClicksAmount();

    if (!theSameName) {
      this.resetCommittedClicksAmount();
      this.chosenColumnNameToSortBy = field_name;
      this.tablesSorting[table_name] = {
        field_name,
        reverse: theSameName,
      };
      this.incrementCommittedClicksAmount();

    } else if (!this.maximalPermittedClicksReached()) {
        this.tablesSorting[table_name] = {
          field_name,
          reverse: !this.tablesSorting[table_name]?.reverse,
        };
      } else {
        this.resetCommittedClicksAmount();
      }

  }

  private getValueByFieldName(field_name, item) {
    if (field_name == 'location') {
      if (item.region || item.country) {
        return `${item.city}, ${item.region}, ${item.country}`;
      } else if (item.city?.name) {
        return `${item.city?.name}, ${item.city?.region?.name}, ${item.city?.region?.country?.name}`;
      } else {
        return '';
      }
    }
    return item[field_name] || '';
  }

  getSorted(table_name, data) {
    let {field_name, reverse} = this.tablesSorting[table_name] ? this.tablesSorting[table_name] : {field_name: null, reverse: false};

    if (!field_name) {
      return data;
    }

    if (!this.chosenColumnNameToSortBy) {
      this.chosenColumnNameToSortBy = field_name;
    } else if (this.chosenColumnNameToSortBy !== field_name) {
      reverse = false;
      this.chosenColumnNameToSortBy = field_name;
    }

    let sorted = [].slice.call(data, 0);

    if (!this.committedClicksAmountWasReset()) {
      if(field_name !== 'title') {
        sorted = sorted.sort((a, b) => {
          const x = this.getValueByFieldName(field_name, (reverse ? a : b));
          const y = this.getValueByFieldName(field_name, (reverse ? b : a));
          return isNaN(x - y) ? x.localeCompare(y) : x - y;
        });
      } else {
        sorted = sorted.sort((a, b) => {
          const x =  this.titlesOrders[this.getValueByFieldName(field_name, (reverse ? a : b))] || 0; //this.getValueByFieldName(field_name, (reverse ? a : b));
          const y = this.titlesOrders[this.getValueByFieldName(field_name, (reverse ? b : a))] || 0; // no key? No problem
          return x - y;
        });
      }

      return sorted;
    }
    return this._playersOfInitialOrder;
  }

  isSelectedFieldName(field_name, table_name) {
    return this.tablesSorting[table_name]?.field_name === field_name
  }

  highlightTopArrow(table_name, field_name) {
    if (!this.tablesSorting[table_name] || this.committedClicksAmountWasReset()) {
      return 'smallSortArrowInactive'
    }
    return this.isSelectedFieldName(field_name, table_name)
      ? !this.tablesSorting[table_name]?.reverse
        ? 'smallSortArrowInactive'
        : 'smallSortArrowChecked'
      : ''
  }

  highlightBottomArrow(table_name, field_name) {
    if (!this.tablesSorting[table_name]) {
      return ''
    }
    return this.isSelectedFieldName(field_name, table_name)
      ? this.tablesSorting[table_name]?.reverse
        ? 'smallSortArrowInactive'
        : 'smallSortArrowChecked'
      : ''
  }

  appendInputIdentifier(identifier: string) {
    this._inputIdentifiersList.push(identifier);
  }

  getInputIdentifierByIndex(index: number): string {
    return this._inputIdentifiersList[index];
  }

  get inputIdentifierListShallowCopy(): string[] {
    return  [...this._inputIdentifiersList];
  }

  getInputIdentifiersListLength(): number {
    return this._inputIdentifiersList.length;
  }

  get lastFocusedInputIndex(): number {
    return this._lastFocusedInputIndex;
  }

  set lastFocusedInputIndex(value) {
    this._lastFocusedInputIndex = value;
  }

  get chosenColumnNameToSortBy() {
    return this._chosenColumnNameToSortBy;
  }

  set chosenColumnNameToSortBy(value){
    this._chosenColumnNameToSortBy = value;
  }

  maximalPermittedClicksReached(): boolean {
    return this._maxAmountOfCommittedClicks === this._amountOfCommittedClicks;
  }

  incrementCommittedClicksAmount(): void  {
    this._amountOfCommittedClicks ++;
  }

  resetCommittedClicksAmount(): void {
    this._amountOfCommittedClicks = 0;
  }

  committedClicksAmountWasReset(): boolean {
    return this._amountOfCommittedClicks === 0;
  }

}
